// Mock On Behalf Of data for development/demo mode without a backend.
// The relationship lists are first-run seed data only: they are used when the
// demo settings blob has no onBehalfOf section yet, never to overwrite saved values.

import type { OnBehalfOfRelationship } from '@/types/timesheetSettings';

export const MOCK_ENTRY_RELATIONSHIPS: OnBehalfOfRelationship[] = [
  { id: 'e1', person: 'Sarah Jones', actingFor: 'John Davis' },
  { id: 'e2', person: 'Sarah Jones', actingFor: 'Lisa Ray' },
  { id: 'e3', person: 'Matt Brown', actingFor: 'Alex Chen' },
];

export const MOCK_APPROVAL_RELATIONSHIPS: OnBehalfOfRelationship[] = [
  { id: 'a1', person: 'Sarah Jones', actingFor: 'John Davis' },
  { id: 'a2', person: 'Matt Brown', actingFor: 'Lisa Ray' },
];

export const MOCK_PEOPLE = [
  'Sarah Jones', 'John Davis', 'Lisa Ray', 'Matt Brown',
  'Alex Chen', 'Emma Wilson', 'Chris Taylor', 'Priya Patel',
];
